import ApplicationError from 'es/app/business-logic/ApplicationError';
import { INotification } from 'es/app/business-logic/Notification';
import Guid from 'es/core/types/Guid';
import { action, computed, makeObservable, observable } from 'mobx';

export default class AppStore {
    constructor() {
        makeObservable<AppStore, '_notifications' | '_errors'>(this, {
            _notifications: observable,
            _errors: observable,
            notifications: computed,
            errors: computed,
            raiseError: action.bound,
            dismissError: action.bound,
            raiseNotification: action.bound,
            dismissNotification: action.bound
        });
    }
    
    private _notifications: INotification[] = [];

    private _errors: ApplicationError[] = [];

    public get notifications() { return this._notifications; }
    public get errors() { return this._errors; }

    public raiseError(raised: ApplicationError) {
        let isDuplicate = false;

        const errors = this._errors.map(err => {
            if (!err.equals(raised)) return err;

            const merged = new ApplicationError(err.message, err.details, err.source);
            merged.count++;

            isDuplicate = true;

            return merged;
        });

        if (!isDuplicate) {
            errors.push(raised);
        }

        this._errors = errors;
    }

    public dismissError(dismissed: ApplicationError) {
        const errors = this._errors.filter(err => !err.equals(dismissed));

        if (errors.length !== this._errors.length) {
            this._errors = errors;
        }
    }

    public raiseNotification(notification: INotification) {
        const hasNotification = this._notifications.some(existing => existing.id === notification.id);
        if (hasNotification) return;

        this._notifications = [...this._notifications, notification];
    }

    public dismissNotification(id: Guid) {
        const notifications = this._notifications.filter(n => n.id !== id);
        if (notifications.length !== this._notifications.length) {
            this._notifications = notifications;
        }
    }
}